import { useEffect } from 'react';
import { useAccount, ConnectorData } from 'wagmi';
interface UseActiveConnectorProps {
  onAccountChange?: (account?: string) => void;
  onAccountDisconnect?: () => void;
  onChainChange?: (chain?: {
    id: number;
    unsupported: boolean;
  }) => void;
}
export const useConnectorChange = ({
  onAccountChange,
  onChainChange,
  onAccountDisconnect
}: UseActiveConnectorProps): void => {
  const {
    connector: activeConnector
  } = useAccount();
  useEffect(() => {
    const handleConnectorUpdate = ({
      account,
      chain
    }: ConnectorData) => {
      if (account && onAccountChange) {
        onAccountChange(account);
      }
      if (chain && onChainChange) {
        onChainChange(chain);
      }
    };
    const handleDisconnection = () => {
      if (onAccountDisconnect) {
        onAccountDisconnect();
      }
    };
    if (activeConnector) {
      activeConnector.on('change', handleConnectorUpdate);
      activeConnector.on('disconnect', handleDisconnection);
    }
    return () => {
      if (activeConnector) {
        activeConnector.off('change', handleConnectorUpdate);
        activeConnector.off('disconnect', handleDisconnection);
      }
    };
  }, [activeConnector, onAccountChange, onAccountDisconnect, onChainChange]);
};